import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

interface viewMode {
    id: string;
    name: string;
    status: string;
    dateUpdate: string;
    channelDescription: string;
    adContent : string;
    pubDateDelay : number;
    type : string;
    defaultArticleCount : number;
    maxArticleCount : number;
}

export class rssFeedsList_template extends vnTemplate {
    public resultInfos: resultsInfo_template;
    protected toolTip: infoButton_template
    protected pubDateDelayToolTip: infoButton_template
    protected maxCountToolTip: infoButton_template
    protected defaultCountToolTip: infoButton_template

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('rssresultInfo', this.getTemplateViewModel(), this.caller);
        this.toolTip = new infoButton_template("rsstoolTip", this.getTemplateViewModel(), this.caller);
        this.toolTip.setContent("<p>Active view modes will be accessible via parameter on RSS feeds. Inactive view modes will not be accessible.</p>");

        this.pubDateDelayToolTip = new infoButton_template("pubDateDelayToolTip", this.getTemplateViewModel(), this.caller);
        this.pubDateDelayToolTip.setContent("<p>The pubDate delay defines how many hours it will wait before including newly published or republished content in the RSS feed.</p>");

        this.maxCountToolTip = new infoButton_template("maxCountToolTip", this.getTemplateViewModel(), this.caller);
        this.maxCountToolTip.setContent("<p>The maximum article count that will ever be loaded by the feed. Even if an 'articleCount=' parameter specifies more, it won't load more than the maximum.</p>");

        this.defaultCountToolTip = new infoButton_template("defaultCountToolTip", this.getTemplateViewModel(), this.caller);
        this.defaultCountToolTip.setContent("<p>The default article count that will be loaded by the feed without parameters. The articleCount= parameter should still be able to request a different number.</p>");
    }

    protected buildViewModel(): any {
        return {
            rssFeedsViewModes: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(['config_rss_feeds'])),
            rssFeedsViewModeToEdit: ko.observable(null),
            canSave: ko.observable(false),

            onClickAddNewRSSFeedViewMode: (...args : any[]) => {
                this.addNewRSSFeedViewMode(args)
            },
            onClickEditRSSFeedViewMode: (...args : any[]) => {
                this.editRSSFeedViewMode(args)
            },
            onClickRemoveDialog: (...args : any[]) => {
                this.removeDialog(args)
            },
            onClickShowDialog: (...args : any[]) => {
                this.showDialog(args)
            }

        };
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }


    protected getTemplateHtml(): string {
        return (
            `
<div class="list-header w-justify">
    <div class="w-left"></div>
    <div class="w-right"></div>
</div>

<div class="w-list-results" id="list-results">
    <table class="list-results">
        ` + this.resultInfos.getHtmlBuild() + `
        <thead>
        <tr>
            <th><span class="icon list-sort-none">View Mode</span></th>
            <th><span class="icon list-sort-none">pubDate Delay (In Hours)</span>
                <div class="w-tooltips-adv pos-bottom short" style="display: inline-block">` + this.pubDateDelayToolTip.getHtmlBuild() + `</div>
            </th>
            <th><span class="icon list-sort-none">Type</span></th>
            <th><span class="icon list-sort-none">Default Article Count</span>
                <div class="w-tooltips-adv pos-bottom short" style="display: inline-block">` + this.defaultCountToolTip.getHtmlBuild() + `</div>
            </th>
            <th><span class="icon list-sort-none">Max Article Count</span>
                <div class="w-tooltips-adv pos-bottom short" style="display: inline-block">` + this.maxCountToolTip.getHtmlBuild() + `</div>
            </th>
            <th><span class="icon list-sort-none">Date Updated</span></th>
            <th><span class="icon list-sort-none" style="display: inline-block">Status</span>
                <div class="w-tooltips-adv pos-bottom short" style="display: inline-block">` + this.toolTip.getHtmlBuild() + `</div>
            </th>

            <th class="align-center"><span>Edit</span></th>
        </tr>
        </thead>

        <tbody data-bind="foreach: rssFeedsViewModes">
            <tr>
                <td><span data-bind="text: value"></span></td>
                <td><span data-bind="text: pubDateDelay"></span></td>
                <td><span data-bind="text: type"></span></td>
                <td><span data-bind="text: defaultArticleCount"></span></td>
                <td><span data-bind="text: maxArticleCount"></span></td>
                <td><span data-bind="text: dateUpdated"></span></td>
                <td><span data-bind="text: status"></span></td>
                <td><button type="button" class="btn border only-icon icon i-edit" data-bind="click : $parent.onClickShowDialog"></button></td>
            </tr>
        </tbody>
    </table>
</div>


<div id="rss-dialog" class="w-lightbox light-theme">
    <div class="lightbox-content">
        <div class="w-form lightbox-form">
            <div class="form-header">
                <h3 class="form-title">Edit View Mode</h3>
                <button type="button"  data-bind="click: onClickRemoveDialog" class="close-button icon i-close-2"></button>
            </div>
            <!-- ko if: rssFeedsViewModeToEdit -->
            <div class="form-body">
                <div class="form-group row" style="width: fit-content;">
                    <legend class="form-legend" data-bind="text : rssFeedsViewModeToEdit().name"></legend>
                </div>

                <!-- ko if: rssFeedsViewModeToEdit().value() == 'syndicationSmartNews' -->
                    <div class="form-group row">
                        <label class="form-label" for="channel_description">channel description</label>
                        <textarea id="channel_description" data-bind="textInput: rssFeedsViewModeToEdit().channelDescription" style="height: 50px;width: 560px;"></textarea>
                    </div>

                    <div class="form-group row">
                        <label class="form-label" for="ad_content">ad content</label>
                        <textarea id="ad_content" data-bind="textInput: rssFeedsViewModeToEdit().adContent" style="height: 150px;width: 560px;"></textarea>
                    </div>
                <!-- /ko -->

                <div class="form-group">
                    <label class="form-label" for="pubDateDelay">pubDate Delay (In Hours)</label>
                    <input class="input-text number" type="number" id="pubDateDelay" data-bind="textInput: rssFeedsViewModeToEdit().pubDateDelay" oninput="this.value = this.value.replace(/\D/g, '')">
                </div>

                <div class="form-group">
                    <label class="form-label" for="defaultArticleCount">Default Article Count</label>
                    <input class="input-text number" type="number" id="defaultArticleCount" data-bind="textInput: rssFeedsViewModeToEdit().defaultArticleCount" oninput="this.value = this.value.replace(/\D/g, '')">
                </div>

                <div class="form-group">
                    <div class="form-check-inline width-auto">
                        <input type="radio" id="statusGroupActive" name="statusGroup" value="active" data-bind="checked: rssFeedsViewModeToEdit().status" />
                        <label class="form-label" for="statusGroupActive">Active</label>
                    </div>
                    <div class="form-check-inline width-auto">
                        <input type="radio" id="statusGroupInactive" name="statusGroup" value="inactive" data-bind="checked: rssFeedsViewModeToEdit().status" />
                        <label class="form-label" for="statusGroupInactive">Inactive</label>
                    </div>
                </div>

             </div>
            <!-- /ko -->

            <div class="form-footer">
                <button type="button" data-bind="click: onClickRemoveDialog" class="btn">Cancel</button>
                <button type="button" data-bind="click: onClickEditRSSFeedViewMode, enable: canSave" class="btn highlight">Save</button>
            </div>
        </div>

    </div>
</div>
            `
        );
    }

    protected getTemplateName(): string {
        return "rssFeedsList_template";
    }

    private addNewRSSFeedViewMode(args) {
        console.error("Not Implemented");
    }

    public setRSSFeeds(viewModes: Array<viewMode>) {
        this.getTemplateViewModel().rssFeedsViewModes(viewModes)
    }

    public setPermissions(permissions : Array<any>) {
        this.getTemplateViewModel().permissions(permissions);
    }


    private editRSSFeedViewMode(args : any[]) {
        const rssFeedsViewModes = this.getTemplateViewModel().rssFeedsViewModes();
        const editedRSSFeedViewMode = ko.toJS(this.getTemplateViewModel().rssFeedsViewModeToEdit());

        rssFeedsViewModes.forEach((viewMode, index) => {
            if (viewMode.id === editedRSSFeedViewMode.id) {
                rssFeedsViewModes[index] = editedRSSFeedViewMode;
            }
        });

        this.unsetRssFeedsViewModeToEdit()

        this.getTemplateViewModel().rssFeedsViewModes(rssFeedsViewModes);
        this.toggleDialog()

        this.caller.saveRssFeedsViewModeData()
    }

    private removeDialog(args) {
        this.toggleDialog();

    }

    private showDialog(args) {
        const [data] = args
        this.toggleDialog();
        this.setRssFeedsViewModeToEdit(data)
    }

    private toggleDialog() {
        const dialog = document.getElementById('rss-dialog');
        dialog.classList.toggle('is-visible')

        if (!dialog.classList.contains('is-visible')) {
            this.unsetRssFeedsViewModeToEdit();
        }

    }

    private formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    private setRssFeedsViewModeToEdit(data : any) {
        const { id, name, status, value, channelDescription, adContent, pubDateDelay, type, defaultArticleCount, maxArticleCount } = data;
        let rssFeedEdit = {
            id: ko.observable(id),
            name: ko.observable(name),
            status: ko.observable(status),
            dateUpdated: ko.observable(this.formatDate(new Date())),
            value: ko.observable(value),
            pubDateDelay: ko.observable(pubDateDelay),
            type: ko.observable(type),
            defaultArticleCount: ko.observable(defaultArticleCount),
            maxArticleCount: ko.observable(maxArticleCount),
        } as any;

        if (value === "syndicationSmartNews") {
            rssFeedEdit.channelDescription = ko.observable(channelDescription);
            rssFeedEdit.adContent = ko.observable(adContent);
        }

        //This will avoid unecessary save if no change occurs
        this.subscribeToChanges(rssFeedEdit);

        this.getTemplateViewModel().rssFeedsViewModeToEdit(rssFeedEdit);
    }

    private subscribeToChanges(rssFeedEdit) {
        const initialRssFeedEdit = ko.toJS(rssFeedEdit);

        // props to track
        const propertiesToSubscribe = ['status', 'channelDescription', 'adContent', 'pubDateDelay', 'defaultArticleCount'];

        // check any changes
        const hasChanges = ko.computed(() => {
            return propertiesToSubscribe.some(prop => {
                return rssFeedEdit[prop] && initialRssFeedEdit[prop] !== rssFeedEdit[prop]();
            });
        });

        // subscribe
        hasChanges.subscribe((hasChanged) => {

            if (this.getTemplateViewModel().canSave() !== hasChanged) {
                this.getTemplateViewModel().canSave(hasChanged);
            }
        });
    }

    private unsetRssFeedsViewModeToEdit() {
        this.getTemplateViewModel()
            .rssFeedsViewModeToEdit(null)
            .canSave(false);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/rssFeedsList_template.ts